import { Component, inject } from '@angular/core'
import { AuthFacade } from '../auth/auth.facade'

@Component({
    selector: 'ppw-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent {
    private auth: AuthFacade = inject(AuthFacade)

    async signInGoogle(): Promise<void> {
        await this.auth.signInGoogle()
    }
}
